import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { flexCenterColumn } from '@seedlang/style_mixins';
import { LeagueTableWrapper } from '@seedlang/hoc';
import React from 'react';
import LeagueZone from './league_zone';

const TableWrapper = styled.div`
  ${flexCenterColumn()}
  width: 100%;
`;

const NoDataMessage = styled.div`
  text-align: center;
  padding: 20px;
  color: ${Theme.gray};
`;

class LeagueTable extends React.Component {
  render() {
    if (!this.props.league || !this.props.league.userLeagues || this.props.league.userLeagues.length === 0) {
      return <NoDataMessage>No league data available</NoDataMessage>;
    }
    return (
      <TableWrapper>
        <LeagueZone
          leagues={this.props.promotionZone}
          color={Theme.green}
          title='Promotion Zone'
          promotionStatus={1}
          titleColor='white'
          iconClass='fa fa-chevron-circle-up'
          showTooltip
          tooltipText='Users in this zone will be promoted to the next league.'
          userId={this.props.userId}
          preview={this.props.preview}
        />
        <LeagueZone
          leagues={this.props.middleZone}
          userId={this.props.userId}
          preview={this.props.preview}
          promotionStatus={0}
        />
        <LeagueZone
          leagues={this.props.demotionZone}
          color={Theme.red}
          title='Demotion Zone'
          titleColor='white'
          iconClass='fa fa-chevron-circle-down'
          showTooltip
          promotionStatus={-1}
          tooltipText='Users in this zone will be demoted to the previous league.'
          userId={this.props.userId}
          preview={this.props.preview}
        />
      </TableWrapper>
    );
  }
}

export default LeagueTableWrapper(LeagueTable);
